module.exports = __webpack_public_path__ + "img/back_barrage_machine.499d1a55.png";